import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c582251"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-keys-table--container absolute w-full" }
const _hoisted_2 = ["data-testid", "onClick"]
const _hoisted_3 = { class: "max-w-[380px] truncate mr-[24px]" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-copy text-[24px] text-Text/text_low" }, null, -1))
const _hoisted_5 = ["showTextLow"]
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = { class: "truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_10 = { class: "truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "text-System/app_error uis uis-exclamation-circle text-[16px] !mr-0"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uis uis-times-circle text-[16px] text-Text/text_lowest mr-[2px]" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Expired ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import elementIds from '@/const/elementIds.json';
import IbOkCancelDialog from '@/components/common/dialogs/OkCancelDialog.vue';
import { computed, inject, ref } from 'vue';
import { IncrediSelect, IncrediTable, IncrediTooltip } from 'incredi-ui';
import 'moment-timer';
import { useApiAccess } from '@/views/settings/settingsApiAccess/settingsApiAccess.helpers';
import { HEADERS, MAP_COLUMNS_To_Key_Roles, MAP_Key_Roles_To_Show } from '@/views/settings/settingsApiAccess/settingsApiAccess.const';
import EditDescriptionCell from '@/views/settings/components/tableCells/editDescriptionCell.vue';
import FloatingDeleteCell from '@/views/settings/components/tableCells/floatingDeleteCell.vue';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { IKApiAccessData } from '@/views/settings/settingsApiAccess/settingsApiAccess.injectionKeys';
import { copyToClipboard } from '@/services/utils';
import { Key_Role } from '@/graphql/codegen/gql/graphql';
import { useMatomo } from '@/services/matomo/matomo.service';
import { dateUtils } from '../../../../services/dateUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'apiKeysTable',
  setup(__props) {

const tooltipHover = ref<null | number>(null);
const { deleteApiKey, daysLeft, editDescription, editAPIUserRole } = useApiAccess();
const { toastMessage } = useNotify();
const { t } = useI18n();
const apiKeysData = inject(IKApiAccessData);
const matomo = useMatomo();
const hoveredRow = ref<number | undefined>(undefined);
const activeRowIndex = ref<number | undefined>(undefined);
const deleteApiKeyDialog = ref(false);
const inputFocus = ref(false);

const getDaysLeft = (index: number) => daysLeft(apiKeysData?.apiKeys.value[index]?.expirationDate);
const showExpirationDateError = (index: number) => daysLeft(apiKeysData?.apiKeys.value[index]?.expirationDate) < 20 && daysLeft(apiKeysData?.apiKeys.value[index]?.expirationDate) >= 0;

const deleteApiKeyCallback = () => {
  deleteApiKeyDialog.value = false;
  deleteApiKey(hoveredRow.value !== undefined ? apiKeysData?.apiKeys.value[hoveredRow?.value]?.key : '');
  matomo?.trackEvent({
    category: 'API Access',
    action: 'Delete key',
  });
};

const handleSortChange = (tableState: any) => {
  if (apiKeysData?.tableState) {
    apiKeysData.tableState.value = tableState;
  }
};

const handleUpdateDescription = async (key: string, data: string) => {
  try {
    await editDescription(key, data);
    toastMessage(t('settings.apiAccess.actionToasts.description.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage(t('settings.apiAccess.actionToasts.description.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  } finally {
    matomo?.trackEvent({
      category: 'API Access',
      action: 'Change Description',
    });
  }
};

const copyApiKeyToClipboard = (textToCopy: string) => {
  if (textToCopy) {
    copyToClipboard(textToCopy);
    toastMessage(t('generic.copiedToClipboard'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  }
  matomo?.trackEvent({
    category: 'API Access',
    action: 'Copy Coordinator id',
  });
};

const handleHoverRow = (index: number | undefined) => {
  if (deleteApiKeyDialog.value) {
    return;
  }
  hoveredRow.value = index;
};

const hoveredRowIndex = computed(() => {
  if (activeRowIndex.value !== undefined) {
    return activeRowIndex.value;
  }
  return hoveredRow.value;
});

const handleMenuVisibility = (index: number, visibility: boolean) => {
  if (visibility) {
    activeRowIndex.value = index;
  } else if (!inputFocus.value) activeRowIndex.value = undefined;
};

const handleApiUserRoleUpdate = async (key: string, value: Key_Role) => {
  try {
    await editAPIUserRole(key, value);
    toastMessage(t('settings.apiAccess.actionToasts.changeRole.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (e) {
    toastMessage(t('settings.apiAccess.actionToasts.changeRole.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_IbxScopedCss = _resolveComponent("IbxScopedCss")!

  return (_openBlock(), _createBlock(_component_IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediTable), {
          "model-value": _unref(apiKeysData)?.tableState.value || { sort: { name: 'Valid Until', descending: true } },
          "data-testid": _unref(elementIds).settings.apiKeys.apiAccessTable,
          "data-cy-table-length": _unref(apiKeysData)?.apiKeys.value.length,
          "row-height": 48,
          "header-tooltip": true,
          columns: _unref(HEADERS) as any,
          items: _unref(apiKeysData)?.apiKeys.value as any,
          resizable: false,
          "sort-name": _unref(apiKeysData)?.tableState.value.sort.name,
          "sort-descending": _unref(apiKeysData)?.tableState.value.sort.descending,
          class: _normalizeClass(["incredi-table shadow-none flex-grow w-full h-full", { 'pointer-events-none': activeRowIndex.value !== undefined }]),
          "hovered-row-prop": _unref(hoveredRowIndex),
          onHoveredRow: handleHoverRow,
          "onUpdate:modelValue": handleSortChange
        }, {
          "floating-row": _withCtx(({ index }: { index: number }) => [
            (index === hoveredRow.value || index === activeRowIndex.value)
              ? (_openBlock(), _createBlock(FloatingDeleteCell, {
                  key: 0,
                  class: _normalizeClass({ 'pointer-events-auto': activeRowIndex.value === index }),
                  "is-hovered": index === hoveredRow.value,
                  "data-testid": _unref(elementIds).settings.apiKeys.deleteAPIKeyRowIndex + '_' + index,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (deleteApiKeyDialog.value = true), ["prevent"]))
                }, null, 8, ["class", "is-hovered", "data-testid"]))
              : _createCommentVNode("", true)
          ]),
          "content-APIKey": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["self-center w-full relative", { 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createVNode(_unref(IncrediTooltip), {
                class: "w-full",
                hover: "",
                delay: 200,
                direction: "bottom-sticky-left",
                "offset-x": 16,
                "model-value": tooltipHover.value === index,
                "onUpdate:modelValue": 
                tooltip => {
                  tooltipHover.value = tooltip ? index : null;
                }
              
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(apiKeysData)?.apiKeys.value[index]?.key), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["max-w-[460px] incredi-table-row truncate grid w-full h-[32px]", [getDaysLeft(index) >= 0 || hoveredRow.value === index || index === activeRowIndex.value ? 'text-Text/text_high' : 'text-Text/text_low']]),
                    "data-testid": _unref(elementIds).settings.apiKeys.apiKeyValueCell + '_' + index,
                    onClick: _withModifiers(() => copyApiKeyToClipboard(_unref(apiKeysData)?.apiKeys.value[index]?.key || ''), ["prevent"])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([{ 'generated-api-key-hover': index === hoveredRow.value || index === activeRowIndex.value }, "max-w-[460px] incredi-table-row api-key-column flex flex-nowrap row items-center w-full font-gordita-medium leading-[17px] text-[13px] justify-between px-[8px] py-[4px] truncate"])
                    }, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(apiKeysData)?.apiKeys.value[index]?.key), 1),
                      _hoisted_4
                    ], 2)
                  ], 10, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["model-value", "onUpdate:modelValue"])
            ], 2)
          ]),
          "content-Description": _withCtx(({ index }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["px-[0px]", { 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", {
                showTextLow: getDaysLeft(index) < 0 && hoveredRow.value !== index,
                class: "edit-input w-full text-[12px] font-gordita-regular leading-[16px] flex items-center"
              }, [
                _createVNode(EditDescriptionCell, {
                  description: _unref(apiKeysData)?.apiKeys.value[index]?.description || '',
                  "max-input-length": 25,
                  "min-input-length": 4,
                  "is-hovered": index === hoveredRow.value,
                  "is-valid": getDaysLeft(index) >= 0,
                  ghost: index !== _unref(hoveredRowIndex),
                  "data-testid": _unref(elementIds).settings.apiKeys.editAPIKeyRowIndex + '_' + index,
                  onBlurWithin: _cache[1] || (_cache[1] = 
                  () => {
                    activeRowIndex.value = undefined;
                    inputFocus.value = false;
                  }
                ),
                  onFocusWithin: 
                  () => {
                    activeRowIndex.value = index;
                    inputFocus.value = true;
                  }
                ,
                  "onUpdate:description": (val) => handleUpdateDescription(_unref(apiKeysData)?.apiKeys.value[index]?.key || '', val)
                }, null, 8, ["description", "is-hovered", "is-valid", "ghost", "data-testid", "onFocusWithin", "onUpdate:description"])
              ], 8, _hoisted_5)
            ], 2)
          ]),
          "content-CreatedBy": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["incredi-table-row", { 'pointer-events-auto': activeRowIndex.value === index }]),
              "data-testid": _unref(elementIds).settings.apiKeys.createdByCell + '_' + index
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: _normalizeClass([getDaysLeft(index) >= 0 ? 'text-Text/text_high' : 'text-Text/text_low'])
                }, _toDisplayString(_unref(apiKeysData)?.apiKeys.value[index]?.createdBy), 3)
              ])
            ], 10, _hoisted_6)
          ]),
          "content-Role": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center px-[2px]", [getDaysLeft(index) >= 0 ? 'text-Text/text_high' : '!text-Text/text_low', activeRowIndex.value === index ? 'pointer-events-auto' : '']])
            }, [
              _createVNode(_unref(IncrediSelect), {
                "data-testid": `${_unref(elementIds).settings.apiKeys.apiKeyRoleCell}` + '_' + _unref(apiKeysData)?.apiKeys.value[index]?.description,
                items: Object.values(_unref(MAP_Key_Roles_To_Show)),
                "model-value": _unref(MAP_Key_Roles_To_Show)[_unref(apiKeysData)?.apiKeys.value[index]?.role as keyof typeof MAP_Key_Roles_To_Show],
                class: "-px-0.5 role-select",
                size: "tiny",
                direction: "bottom-sticky-left",
                disabled: getDaysLeft(index) < 0,
                borderless: getDaysLeft(index) < 0 || (hoveredRow.value && index !== hoveredRow.value) || index !== _unref(hoveredRowIndex),
                onMenuVisibility: val => handleMenuVisibility(index, val),
                "onUpdate:modelValue": (value) =>handleApiUserRoleUpdate(_unref(apiKeysData)?.apiKeys.value[index]?.key || '',_unref(MAP_COLUMNS_To_Key_Roles)[value as keyof typeof MAP_COLUMNS_To_Key_Roles])
              }, null, 8, ["data-testid", "items", "model-value", "disabled", "borderless", "onMenuVisibility", "onUpdate:modelValue"])
            ], 2)
          ]),
          "content-LastUsed": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["incredi-table-row", { 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center", [getDaysLeft(index) >= 0 ? 'text-Text/text_high' : 'text-Text/text_low']])
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(apiKeysData)?.apiKeys.value[index]?.lastUsed ? _unref(dateUtils).getFormattedDate(_unref(apiKeysData)?.apiKeys.value[index]?.lastUsed) : 'New'), 1)
              ], 2)
            ], 2)
          ]),
          "content-ValidUntil": _withCtx(({ index }: { index: number }) => [
            _createElementVNode("div", {
              "data-testid": _unref(elementIds).settings.apiKeys.validUntilCell + '_' + index,
              class: _normalizeClass(["px-[16px] flex items-center", { 'pointer-events-auto': activeRowIndex.value === index }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass([getDaysLeft(index) >= 0 ? 'text-Text/text_high' : 'text-Text/text_low'])
                }, _toDisplayString(_unref(dateUtils).getFormattedDate(_unref(apiKeysData)?.apiKeys.value[index]?.expirationDate)), 3)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass([getDaysLeft(index) >= 0 || hoveredRow.value === index ? 'text-Text/text_medium' : 'text-Text/text_low'])
                }, [
                  (showExpirationDateError(index))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                    : _createCommentVNode("", true),
                  (getDaysLeft(index) >= 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass({ 'expiration-date-error pl-1': showExpirationDateError(index) })
                      }, _toDisplayString(getDaysLeft(index)) + " days left", 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_15))
                ], 2)
              ])
            ], 10, _hoisted_8)
          ]),
          _: 1
        }, 8, ["model-value", "data-testid", "data-cy-table-length", "columns", "items", "sort-name", "sort-descending", "hovered-row-prop", "class"]),
        _createVNode(IbOkCancelDialog, {
          value: deleteApiKeyDialog.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((deleteApiKeyDialog).value = $event)),
          "dialog-title": _ctx.$t('settings.apiAccess.deleteDialog.title'),
          body: _ctx.$t('settings.apiAccess.deleteDialog.description'),
          "ok-label": "Delete",
          onOk: deleteApiKeyCallback,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (deleteApiKeyDialog.value = false)),
          onHide: _cache[4] || (_cache[4] = ($event: any) => (deleteApiKeyDialog.value = false))
        }, null, 8, ["value", "dialog-title", "body"])
      ])
    ]),
    _: 1
  }))
}
}

})